import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ActionsSubject, Store } from '@ngrx/store';
import { DbHistoryDialog, ND } from '@pt/pt-models';
import { DataBreachProcessService } from '@pt/api-client';
import {
  ListDataBreachHistoryResponse
} from 'it/primatoo/openapi/api/org/schemas/databreachprocess/ListDataBreachHistoryResponse';


@Component({
  selector: 'pt-db-history-dialog',
  templateUrl: 'db-history-dialog.component.html',
  styleUrls: [`db-history-dialog.component.scss`]
})
export class DbHistoryDialogComponent {
  public dbHistoryDialog: DbHistoryDialog;
  public loading = false;
  public history: ListDataBreachHistoryResponse = { items: [] };

  public readonly iconEmpty = 'library-outline';
  public readonly iconSize = 18;

  public readonly ND = ND;

  constructor(
    public store: Store,
    public activeModal: NgbActiveModal,
    public actionsSubject: ActionsSubject,
    private dataBreachProcessService: DataBreachProcessService
  ) {
  }


  init(historyDialog: DbHistoryDialog) {
    this.loading = true;
    this.dbHistoryDialog = historyDialog;
    this.dataBreachProcessService.getHistory(this.dbHistoryDialog.dataBreachId).subscribe((success) => {
      this.history = success;
      this.loading = false;
    }, () => {
      this.history = { items: [] };
      this.loading = false;
    });
  }
}
